import { createBrowserHistory } from "history";

import { MOUNT_PATH } from "../lib/mount";

const history = createBrowserHistory({ basename: MOUNT_PATH });

const preserveWebview = (path) => {
  if (new URLSearchParams(window.location.search).get("webview") !== "true") return path;

  if (typeof path === "string") {
    const [pathname, search] = path.split("?");
    const params = new URLSearchParams(search);
    if (!params.has("webview")) params.set("webview", "true");
    return `${pathname}?${params.toString()}`;
  }

  // path is a location object { pathname, search, ... }
  const params = new URLSearchParams(path.search || "");
  if (!params.has("webview")) params.set("webview", "true");
  return { ...path, search: `?${params.toString()}` };
};

const originalPush = history.push.bind(history);
const originalReplace = history.replace.bind(history);
history.push = (path, state) => originalPush(preserveWebview(path), state);
history.replace = (path, state) => originalReplace(preserveWebview(path), state);

export default history;
